const STORAGE_KEY = 'collection-image-view';

/** @typedef {'model' | 'product'} CollectionImageView */

/** @returns {CollectionImageView} */
function getStoredView() {
  const value = localStorage.getItem(STORAGE_KEY);
  return value === 'product' ? 'product' : 'model';
}

/** @param {CollectionImageView} value */
function setStoredView(value) {
  localStorage.setItem(STORAGE_KEY, value);
}

/** @param {HTMLElement} root */
function findResultsList(root) {
  const resultsList = root.closest('results-list') || document.querySelector('results-list');
  return resultsList instanceof HTMLElement ? resultsList : null;
}

/** @param {HTMLButtonElement} button */
function applyView(button) {
  const resultsList = findResultsList(button);
  if (!resultsList) return;

  const view = getStoredView();
  resultsList.setAttribute('data-collection-image-view', view);

  const isModel = view === 'model';
  button.classList.toggle('is-model', isModel);
  button.setAttribute('aria-pressed', String(!isModel));

  const galleries = resultsList.querySelectorAll('.card-gallery[data-has-product-view-image="true"] slideshow-component');
  for (const slideshow of galleries) {
    if (!(slideshow instanceof HTMLElement)) continue;
    slideshow.setAttribute('initial-slide', view === 'product' ? '0' : '1');
  }
}

/** @param {HTMLButtonElement} button */
function toggleView(button) {
  const current = getStoredView();
  const next = current === 'model' ? 'product' : 'model';
  setStoredView(next);
  applyView(button);
}

function init() {
  /** @type {NodeListOf<HTMLButtonElement>} */
  const buttons = document.querySelectorAll('button[data-toggle-model-product]');
  if (!buttons.length) return;

  for (const button of buttons) {
    applyView(button);
    button.addEventListener('click', () => toggleView(button));
  }

  // Re-apply after infinite scroll / section rendering updates.
  const observer = new MutationObserver(() => {
    for (const button of buttons) applyView(button);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

init();
